module.exports = __webpack_public_path__ + "img/donante-party-land.17c8b9e7.png";